export default __webpack_public_path__ + "static/media/star.85ca60d6.svg";